module.exports = __webpack_public_path__ + "static/uw-logo-05694f15038508cdb6c243922f1912be.svg";